export default __webpack_public_path__ + "static/char-s-43-ko-1668ae4c0e1a02b76444fc987c6292e9.webp";